import { render, staticRenderFns } from "./CreateEditFamilyType.vue?vue&type=template&id=e207749a&"
import script from "./CreateEditFamilyType.vue?vue&type=script&lang=js&"
export * from "./CreateEditFamilyType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports